// extracted by mini-css-extract-plugin
export var column = "column-module--column--bce15";